import { Check, Copy, Share2 } from 'lucide-react';
import { useState } from 'react';
import { canNativeShare, copyText, shareOrCopy } from '@/services/share';
import { toast } from '@/stores/toastStore';

interface ShareButtonsProps {
  title: string;
  text: string;
  url?: string;
  copyLabel?: string;
  shareLabel?: string;
  size?: 'md' | 'lg';
}

export function ShareButtons({ title, text, url, copyLabel = '링크 복사', shareLabel = '공유하기', size = 'md' }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);
  const sizeClass = size === 'lg' ? 'btn-lg' : 'btn-md';

  const handleCopy = async () => {
    const ok = await copyText(url ?? text);
    if (ok) {
      setCopied(true);
      toast(url ? '링크를 복사했어요!' : '결과를 복사했어요!', 'success');
      setTimeout(() => setCopied(false), 2000);
    } else {
      toast('복사에 실패했어요. 주소창에서 직접 복사해주세요.', 'error');
    }
  };

  const handleShare = async () => {
    const outcome = await shareOrCopy({ title, text, url });
    if (outcome === 'copied') toast('공유를 지원하지 않는 환경이라 복사했어요!', 'success');
    else if (outcome === 'failed') toast('공유에 실패했어요.', 'error');
  };

  return (
    <div className="flex w-full flex-col gap-2 sm:flex-row">
      <button type="button" onClick={handleCopy} className={`btn-secondary ${sizeClass} flex-1`}>
        {copied ? <Check size={18} aria-hidden="true" /> : <Copy size={18} aria-hidden="true" />}
        {copied ? '복사 완료!' : copyLabel}
      </button>
      <button type="button" onClick={handleShare} className={`btn-accent ${sizeClass} flex-1`}>
        <Share2 size={18} aria-hidden="true" />
        {canNativeShare() ? shareLabel : `${shareLabel} (복사)`}
      </button>
    </div>
  );
}
